import React from 'react';
import classnames from 'classnames';
import { Button } from 'swag-client-common/components/ui/button';
import AnimationWrapper from 'swag-client-common/components/animation-wrapper';
import { ViewIdToScroll } from 'swag-common/constants/other';
import commonClasses from '../../what-we-offer.scss';
import classes from './ready-to-find-form.module.scss';
import { ContactForm } from './components/contact-form';
export const ReadyToFindFormComponent = ({
  valid,
  isShown,
  onSubmitRequest,
  text,
  additionalText,
  headingText,
  bodyText,
  shouldShowBodyTextPlaceholder
}) => {
  const isInIFrame = window.self !== window.top;
  const shouldShowTextPlaceholder = isInIFrame && !bodyText && shouldShowBodyTextPlaceholder;
  return /*#__PURE__*/React.createElement(AnimationWrapper, {
    className: classes.container,
    offset: 150
  }, isShown ? /*#__PURE__*/React.createElement("div", {
    id: ViewIdToScroll,
    className: classnames(classes.header, classes.headerSent)
  }, /*#__PURE__*/React.createElement("span", {
    className: classnames(commonClasses.title, classes.title)
  }, text), /*#__PURE__*/React.createElement("span", {
    className: classnames(commonClasses.text, classes.text)
  }, additionalText)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.header
  }, /*#__PURE__*/React.createElement("span", {
    className: classnames(commonClasses.title, classes.title)
  }, headingText || 'Ready to find out more?'), /*#__PURE__*/React.createElement("span", {
    className: classnames(commonClasses.text, classes.text)
  }, shouldShowTextPlaceholder ? 'Write some body copy here...' : bodyText)), /*#__PURE__*/React.createElement("div", {
    className: classes.body
  }, /*#__PURE__*/React.createElement(ContactForm, null)), /*#__PURE__*/React.createElement("div", {
    className: classes.footer
  }, /*#__PURE__*/React.createElement(Button, {
    className: classes.button,
    type: "primary",
    disabled: !valid,
    onClick: onSubmitRequest
  }, "Get In Touch"))));
};